import {Component, Input} from "@angular/core";
import {Occasion} from "../../../../../../../../../server/src/base/entities/occasion/Occasion";
import {ISchiltzFacebookService} from "../../../../../../domain/facebook/ISchiltzFacebookService";

@Component({
    selector: 'admin-occasion',
    styleUrls: ['./adminOccasion.scss'],
    templateUrl: './adminOccasion.html'
})
export class AdminOccasionComponent {
    @Input() occasion:Occasion;

    private facebookService:ISchiltzFacebookService;
    public shared:boolean;

    constructor(facebookService: ISchiltzFacebookService) {
        this.facebookService = facebookService;
    }

    ngOnInit(){
        this.shared = false;
    }

    public share(){
        this.facebookService.Share(this.occasion.link).then(() => {
            this.shared = true;
        }).catch(err => {
            console.log(err);
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/occasions/presentation/adminOccasion/adminOccasion.ts